var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventNewSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 6C0.5 3.23858 2.73858 1 5.5 1H15.5C18.2614 1 20.5 3.23858 20.5 6V15C20.5 17.7614 18.2614 20 15.5 20H5.5C2.73858 20 0.5 17.7614 0.5 15V6ZM5.5 3C3.84315 3 2.5 4.34315 2.5 6V15C2.5 16.6569 3.84315 18 5.5 18H15.5C17.1569 18 18.5 16.6569 18.5 15V6C18.5 4.34315 17.1569 3 15.5 3H5.5Z",
    fill: "#2400FF",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 0C7.05228 0 7.5 0.447715 7.5 1V4C7.5 4.55228 7.05228 5 6.5 5C5.94772 5 5.5 4.55228 5.5 4V1C5.5 0.447715 5.94772 0 6.5 0Z",
    fill: "#2400FF",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70703 7.27539C4.70703 6.72311 5.15475 6.27539 5.70703 6.27539L6.70703 6.27539C7.25932 6.27539 7.70703 6.72311 7.70703 7.27539C7.70703 7.82768 7.25932 8.27539 6.70703 8.27539H5.70703C5.15475 8.27539 4.70703 7.82767 4.70703 7.27539Z",
    fill: "#2400FF",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53467 7.30987C8.53467 6.73854 8.828 6.27539 9.18984 6.27539H15.7416C16.1034 6.27539 16.3967 6.73854 16.3967 7.30987C16.3967 7.8812 16.1034 8.34436 15.7416 8.34436H9.18984C8.828 8.34436 8.53467 7.8812 8.53467 7.30987Z",
    fill: "#2400FF",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70703 11C4.70703 10.4477 5.15475 10 5.70703 10L6.70703 10C7.25932 10 7.70703 10.4477 7.70703 11C7.70703 11.5523 7.25932 12 6.70703 12H5.70703C5.15475 12 4.70703 11.5523 4.70703 11Z",
    fill: "#2400FF",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53467 11.0345C8.53467 10.4632 8.828 10 9.18984 10H15.7416C16.1034 10 16.3967 10.4632 16.3967 11.0345C16.3967 11.6058 16.1034 12.069 15.7416 12.069H9.18984C8.828 12.069 8.53467 11.6058 8.53467 11.0345Z",
    fill: "#2400FF",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70703 14.7236C4.70703 14.1713 5.15475 13.7236 5.70703 13.7236L6.70703 13.7236C7.25932 13.7236 7.70703 14.1713 7.70703 14.7236C7.70703 15.2759 7.25932 15.7236 6.70703 15.7236H5.70703C5.15475 15.7236 4.70703 15.2759 4.70703 14.7236Z",
    fill: "#2400FF",
    fillOpacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53467 14.7581C8.53467 14.1868 8.828 13.7236 9.18984 13.7236H15.7416C16.1034 13.7236 16.3967 14.1868 16.3967 14.7581C16.3967 15.3294 16.1034 15.7926 15.7416 15.7926H9.18984C8.828 15.7926 8.53467 15.3294 8.53467 14.7581Z",
    fill: "#2400FF",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 0C15.0523 0 15.5 0.447715 15.5 1V4C15.5 4.55228 15.0523 5 14.5 5C13.9477 5 13.5 4.55228 13.5 4V1C13.5 0.447715 13.9477 0 14.5 0Z",
    fill: "#2400FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventNewSelected);
export default __webpack_public_path__ + "static/media/eventNewSelected.8bf88fd61ea5c80d69e03201c3a9ab2a.svg";
export { ForwardRef as ReactComponent };